var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.219 9.5c-.383 0-.656.3-.656.656v3.063c0 .136-.11.219-.22.219H2.032c-.136 0-.219-.083-.219-.22V4.907c0-.11.083-.218.22-.218h3.062a.648.648 0 0 0 .656-.657c0-.355-.3-.656-.656-.656H2.03C1.184 3.375.5 4.085.5 4.906v8.313c0 .847.684 1.531 1.531 1.531h8.313c.82 0 1.531-.684 1.531-1.531v-3.063c0-.355-.3-.656-.656-.656zM13.844.75H9.25c-.383 0-.656.3-.656.656 0 .383.273.657.656.657h3.008L5.504 8.816c-.274.274-.274.684 0 .93.11.137.273.191.465.191a.544.544 0 0 0 .437-.19l6.782-6.755V6c0 .383.273.656.656.656A.648.648 0 0 0 14.5 6V1.406c0-.355-.3-.656-.656-.656z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewProfileIcon);
export default __webpack_public_path__ + "static/media/ViewProfileIcon.f485317c47452eca767131730d2da38b.svg";
export { ForwardRef as ReactComponent };